import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { queryFnGET } from "api/tanStackQuery/helpers";
import { InfrastructureEventType } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/responseSchema";
import { FC } from "react";
import { Alert, Skeleton } from "shared/components/Spor";

type RelatedIncidentProps = {
  incidentId: string;
};

export const RelatedIncident: FC<RelatedIncidentProps> = ({ incidentId }) => {
  const { data, status } = useQuery({
    queryKey: ["relatedIncident", incidentId],
    queryFn: ({ signal }) =>
      queryFnGET<InfrastructureEventType>({
        signal,
        url: `${getBackendUrl()}/infrastructure-event/by-incident-id/NO?incidentId=${incidentId}`,
      }),
    staleTime: 0,
  });

  const getContent = () => {
    switch (status) {
      case "pending":
        return <Skeleton height="36px" width="100%" />;
      case "success":
        return (
          <Alert
            data-color="info"
            width="100%"
            title="Oppsummering infrastrukturhendelse"
          >
            {data.infrastructureInformation.message}
          </Alert>
        );
      case "error":
        return (
          <Alert data-color="critical">
            Kunne ikke hente tilknyttet infrastrukturhendelse
          </Alert>
        );
    }
  };

  return getContent();
};
